import { render, staticRenderFns } from "./SunHeroCallout.vue?vue&type=template&id=7ed1665e&scoped=true"
import script from "./SunHeroCallout.vue?vue&type=script&lang=js"
export * from "./SunHeroCallout.vue?vue&type=script&lang=js"
import style0 from "./SunHeroCallout.vue?vue&type=style&index=0&id=7ed1665e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed1665e",
  null
  
)

export default component.exports